export const navigation = [
  {
    name: 'menu.first',
    destination: true,
    href: '/',
    links: [{ name: 'menu.destination', href: '/sitemap/destinations' }],
  },
  { name: 'menu.second', href: '/onboarding' },
  {
    title: 'menu.sixth',
    links: [
      {
        name: 'blog.hero.title',
        href: '/blogs',
        dataTestId: 'menu-link-blogs',
      },
      { name: 'about.hero.title', href: '/about' },
      { name: 'partner.hero.title', href: '/partners' },
    ],
  },
  {
    title: 'menu.third',
    links: [
      {
        name: 'menu.seventh',
        href: '/pricing',
        dataTestId: 'menu-link-pricing',
      },
      { name: 'menu.eighth', href: '/security' },
      { name: 'menu.ninth', href: '/insurance' },
    ],
  },
];
